// extracted by mini-css-extract-plugin
export default {"subtotalRow":"aDjYhB"};